/// <amd-module name="Core/Medius.Core.Web/Scripts/components/procurement/cartLineId"/>
import { newGuid } from "Core/Medius.Core.Web/Scripts/lib/uniqueGuid";

export const newCartLineId = () => newGuid();